<template>
  <div>
    <main id="main">
      <Loading :isProcessing="isProcessing"></Loading>
      <div class="l-contents">
        <h1 class="l-pageTitle">パスワード初期化</h1>
        <div class="l-contentsBox">
          <table class="l-form-table">
            <tr>
              <th class="v-middle"><span>メールアドレス</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model.trim="$v.form.$model.mailAddress" placeholder="メールアドレス" name="mailAddress" />
                  <ValidationErrorMessage v-show="$v.form.mailAddress.$error && !$v.form.mailAddress.required" validation="required" />
                  <ValidationErrorMessage v-show="$v.form.mailAddress.$error && !$v.form.mailAddress.email" validation="email" />
                </div>
              </td>
            </tr>
            <tr>
              <th class="v-middle"><span>確認用メールアドレス</span></th>
              <td class="v-middle">
                <div class="l-inputAccount">
                  <TextBox v-model.trim="$v.form.$model.mailAddressConfirm" placeholder="確認用メールアドレス" name="mailAddress" />
                  <ValidationErrorMessage v-show="$v.form.mailAddressConfirm.$error && !$v.form.mailAddressConfirm.required" validation="required" />
                  <ValidationErrorMessage v-show="$v.form.mailAddressConfirm.$error && !$v.form.mailAddressConfirm.email" validation="email" />
                  <ValidationErrorMessage v-show="$v.form.mailAddressConfirm.$error && !$v.form.mailAddressConfirm.sameAsMailAddress" validation="sameAsMailAddress" />
                </div>
              </td>
            </tr>
          </table>
          <div class="l-contentsBox__bottom" style="text-align: center;">
            <div class="btn-basic is-inlne is-primary js-savebtn" @click="send()"><a>送信</a></div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { required, email, sameAs } from 'vuelidate/lib/validators';

export default {
  components: {
    Loading,
    TextBox,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      isSupple: false,
      form: {
        mailAddress: null,
        mailAddressConfirm: null,
      }
    }
  },
  validations: {
    form: {
      mailAddress: {
        required,
        email
      },
      mailAddressConfirm: {
        required,
        email,
        sameAsMailAddress: sameAs('mailAddress'),
      }
    }
  },
  created: function() {
    this.isSupple = Object.keys(this.$route.query).includes('supple')
  },
  methods: {
    async send() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/password/resetRequest', {
          mailAddress: this.form.mailAddress,
        });
        if (res.status === 200) {
          if (!this.isSupple) {
            this.$router.push({ name: 'password-modify-input' });
          }
          else {
            this.$router.push({ name: 'password-modify-input', query: {supple: null} });
          }
        } else {
          this.$toast.error(res.data.message);
        }
      }
      this.isProcessing = false;
    }
  }
}

</script>
